<template>
  <div>
    <h1 v-if="!validating_token && token_valid">Token Valid</h1>
    <input
      type="password"
      name="password"
      v-model="input.password"
      :placeholder="'reset_password.form.password' | translate"
    />
    <input
      type="password"
      name="password"
      v-model="input.password_again"
      :placeholder="'reset_password.form.password_again' | translate"
    />
    <button type="button" :disabled="!form_valid" v-on:click="updatePassword">
      Reset Password
    </button>
  </div>
</template>

<script>
import { resetPassword, verifyPasswordToken } from "../services/api";
const field_validations = {
  password: password => !!password,
  password_again: (password, state) =>
    password && password === state.input.password
};
export default {
  name: "Register",
  data() {
    return {
      input: {
        password: null,
        password_again: null
      },
      validating_token: true,
      token_valid: false
    };
  },
  computed: {
    form_valid() {
      return Object.keys(this.input).every(key =>
        field_validations[key](this.input[key], { input: this.input })
      );
    }
  },
  methods: {
    async updatePassword(event) {
      event && event.preventDefault();
      const { password } = this.input;
      const verificationToken = this.$router.currentRoute.query
        .verificationToken;
      // console.log(password, verificationToken);
      const res = await resetPassword(password, verificationToken);
      if (!(res instanceof Error)) {
        this.$bvToast.toast("User created", {
          title: "Success",
          autoHideDelay: 5000,
          variant: "success"
        });
        this.$router.push({ name: "Login" });
      }
    },
    async verifyPasswordToken(verificationToken) {
      const verified = await verifyPasswordToken(verificationToken);
      this.validating_token = false;
      this.token_valid = verified.data;
    }
  },
  created: function() {
    const verificationToken = this.$router.currentRoute.query.verificationToken;
    this.verifyPasswordToken(verificationToken);
  }
};
</script>

<style scoped></style>
